import agency from './agency';
import bill from './bill';
import purse from './purse';
import recharge from './recharge';
import rule from './rule';
import task from './task';

export default {
  common: {
    success: 'نجاح',
    days: 'أيام',
    task: 'مهمة',
    next: 'التالي',
    previous: 'سابق',
    change: 'يتغير',
    noData: 'لا توجد بيانات',
    cancel: 'إلغاء',
    rule: 'القاعدة',
    exchange: 'التبادل',
    confirm: 'تأكيد',
    notice: 'ملاحظة',
    send: 'إرسال',
    received: 'المستلم',
    recipient: 'المستلم',
    agency: 'الوكالة',
    country: 'البلد',
    channel: 'قناة',
    account: 'حساب',
    fullName: 'الاسم الكامل',
    currency: 'العملة',
    bankName: 'اسم البنك',
    bankCode: 'رمز البنك',
    address: 'العنوان',
    targetOrg: 'هدف المنظمة',
    save: 'حفظ .',
    ID: 'ID: {{id}}',
    bank: 'بانك',
    invite: 'دعوة',
    information: 'المعلومات',
    edit: 'تعديل',
    announce: 'الإعلان',
    member: 'العضو',
    taskn: 'المهمة {{n}}',
    fromAlbum: 'من الألبوم',
    takePhoto: 'أخذ صورة',
    delete: 'حذف',
    supportCountry: 'بلد الدعم',
    enter: 'دخل',
    noUser: 'لا يوجد مستخدم',
    enterId: 'أدخل معرف',
    recharge: 'إعادة الشحن',
    warning: 'تحذير',
  },
  error: {
    systemFatal: 'هناك شيء خاطئ . يرجى المحاولة مرة أخرى في وقت لاحق .',
  },
  agency,
  bill,
  purse,
  recharge,
  rule,
  task,
};
